import React, {useRef} from "react";
import PropTypes from "prop-types";
import FauxHeaderInline from "components/Shared/FauxHeader/FauxHeaderInline";

// temporary fix/replacement for FauxHeader and resizeObserver bug that causes app to crash everytime? 
const FauxHeader2 = ({
  title,
  children
}) => {
  const childrenContainerRef = useRef(null);
  const childrenRef = useRef(null);

  if (children.props.children.length > 0 && document.querySelector(".app-header")) {
    document.querySelector(".app-header").style.display = "none";
    document.querySelector(".app-body").style.height = "calc(100vh - 50px - -25px)";
  }

  return (
    <div className={"FauxHeader-Root"}>
      <div className={"FauxHeader-Title"}>{title}</div>
      <div ref={childrenContainerRef} className={"FauxHeader-ChildrenContainer"}>
        <div ref={childrenRef} className={"FauxHeader-Children"}>
          <FauxHeaderInline>
            {children}
          </FauxHeaderInline>
        </div>
      </div>
    </div>
);
};

FauxHeader2.defaultProps = {
  title: "",
};

FauxHeader2.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
};

export default FauxHeader2;